module.exports = __webpack_public_path__ + "img/atadas2.334b1cd7.jpg";